import { Plus } from 'lucide-react';
import { Button } from '@components/ui/button/Button';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import { useCreatePopup } from '../../hooks/useCreatePopup';
import { CreatePopupModal, type CreatePopupModalRef } from '../modals/CreatePopupModal';
import type { CreatePopupFormData } from '../../models/CreatePopupSchema';

interface CreatePopupButtonProps {
  onPopupCreated?: () => void;
}

export function CreatePopupButton({ onPopupCreated }: CreatePopupButtonProps) {
  const { t } = useTranslation('popups');
  const modalRef = useRef<CreatePopupModalRef>(null);
  const createPopupMutation = useCreatePopup();

  const handleCreate = async (data: CreatePopupFormData) => {
    await createPopupMutation.mutateAsync(data);
    onPopupCreated?.();
  };

  return (
    <>
      <Button
        variant="primary"
        size="default"
        data-testid="create-popup-button"
        onClick={() => modalRef.current?.open()}
      >
        <Plus className="h-4 w-4" aria-hidden />
        {t('buttons.create')}
      </Button>

      <CreatePopupModal ref={modalRef} onSubmit={handleCreate} isLoading={createPopupMutation.isPending} />
    </>
  );
}
